import { makeEntityScaffold } from '@classpass/saga-tools';

import URLS from 'constants/urls';
import { transformV2ClientResponse } from 'helpers/core';

const handler = ({ httpClient }, venueId) => {
  const endpoint = URLS.user.getEmailBounceStatus(venueId);
  return httpClient.get(endpoint).then(transformV2ClientResponse);
};

export default makeEntityScaffold('SAGA.API.BRAZE_DATA', handler);
